import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import googlePlaceApi, {
  ReadCallbackData as GooglePlaceReadCallbackData,
  SearchCallbackData as GooglePlaceSearchCallbackData
} from '../apis/googlePlace.api'
import addressService from '../services/address.service'
import SearchPicker, { SearchPickerOption } from './SearchPicker'

interface Props {
  onSelect: (address: GooglePlaceReadCallbackData) => void
}

interface State {
  address: string
  addresses: GooglePlaceSearchCallbackData
  placeId: string
}

export default class AddressSearchPicker extends Component<Props, State> {
  initialState: State = {
    address: '',
    addresses: [],
    placeId: ''
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleAddressSearch = this.handleAddressSearch.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleAddressSelect = this.handleAddressSelect.bind(this)
  }

  get addressSearchOptions () {
    return addressService.searchOptions(this.state.addresses)
  }

  handleAddressSearch (name: string, term: string) {
    if (!term) {
      this.setState({ addresses: [] })
      return
    }
    googlePlaceApi.search(term, addresses => {
      if (!addresses) return
      this.setState({ addresses })
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'address') this.setState({ placeId: '', address: value })
  }

  handleAddressSelect (name: string, option: SearchPickerOption) {
    const placeId = option.id as string
    this.setState({ placeId, addresses: [] })
    googlePlaceApi.read(placeId, address => {
      if (!address) return
      this.props.onSelect(address)
    })
  }

  render () {
    return (
      <SearchPicker
        name="address"
        value={this.state.address}
        options={this.addressSearchOptions}
        label={i18n("Address")}
        onSearch={this.handleAddressSearch}
        onChange={this.handleInputChange}
        onSelect={this.handleAddressSelect} />
    )
  }
}
